import React from 'react';
import { compose, withProps } from 'recompose';
import { RadioInput } from 'components/core/RadioInput';

import './Checkbox.scss';
import { withClickTracking } from 'components/core/library/tracking-utils';

export const enhance = compose(
	withProps(({ error }) => ({
		className: 'ss-checkbox',
		type: 'checkbox',
		children: !!error && <div className="error-message">{error}</div>,
	})),
	withClickTracking,
);

export default enhance(RadioInput);
